var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loaded
    ? _c(
        "DIV",
        { staticClass: "badge border" },
        [
          _c("ItpIcon", { attrs: { icon: "mdi:payment-clock" } }),
          _vm._v(" "),
          _vm.value.description
            ? _c("span", [
                _vm._v("\n    " + _vm._s(_vm.value.description) + "\n  ")
              ])
            : _vm._e(),
          _vm._v(" "),
          !_vm.value.description
            ? _c("span", [
                _c("span", [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.dueDateRuleAnchorOptions[_vm.value.anchor].name
                      ) +
                      "\n    "
                  )
                ]),
                _vm._v(" "),
                _vm.value.offset_days
                  ? _c("span", [
                      _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.value.offset_days > 0 ? "+" : "-") +
                            "\n      "
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.value.offset_days) +
                            "\n      "
                        )
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }